// extracted by mini-css-extract-plugin
export default {"sub-title":"SellerInfo_sub-title__84c-k"};